import React from 'react';

class TabelaBases extends React.Component {

    formatMoney = (value) => {
        if (value === null || value === undefined || value === '') {
            return '-';
        }

        const number = Number(value);

        if (Number.isNaN(number)) {
            return '-';
        }

        return number.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    renderUpdateStatus = (status) => {
        if (status === 'Pendente') {
            return (
                <span className="badge badge-danger">
                    {status}
                </span>
            );
        }

        if (status === 'Concluído') {
            return (
                <span className="badge badge-success">
                    {status}
                </span>
            );
        }

        if (status === 'Em Andamento') {
            return (
                <span className="badge badge-primary">
                    {status}
                </span>
            );
        }

        return null;
    };

    renderBuildingStatus = (base) => {
        const status = base.status;

        return (
            <div className="d-flex justify-content-center align-items-center gap-5 flex-nowrap">

                {/* Aqui futuramente podemos trazer a lógica de */}
                {/* comparaPeriodoComUltimoDaCidade() */}

                {status === 'Ativo' && (
                    <span className="badge bg-success flex-shrink-0 m-1">
                        {status}
                    </span>
                )}

                {[
                    'Esgotado',
                    'Esgotado Incompleto',
                    'Refutado',
                ].includes(status) && (
                    <span className="badge bg-danger flex-shrink-0 m-1">
                        {status}
                    </span>
                )}

                {[
                    'Suspenso',
                    'Cooperativa',
                ].includes(status) && (
                    <span className="badge bg-warning text-dark flex-shrink-0 m-1">
                        {status}
                    </span>
                )}

                {[
                    'Futuro',
                    'Lançado',
                ].includes(status) && (
                    <span className="badge bg-info text-dark flex-shrink-0 m-1">
                        {status}
                    </span>
                )}
            </div>
        );
    };

    render() {
        const {
            bases,
            selectedBases,
            onToggleBase,
            onToggleAll,
            onShowModalAvaliacao,
        } = this.props;

        const data = bases?.data || [];

        return (
            <>
                <div
                    className=""
                    style={{
                        overflowY: 'scroll',
                    }}
                >
                    <table className="table table-hover table-condensed table-striped cidades">

                        <thead>
                            <tr
                                className="text-center p-10"
                                style={{
                                    backgroundColor: '#5B7537',
                                    color: 'white',
                                    border: '#5B7537 1px solid',
                                }}
                            >
                                <th>
                                    <input
                                        type="checkbox"
                                        className="checkbox check_all"
                                        checked={
                                            data.length > 0 &&
                                            data.every((base) =>
                                                selectedBases.includes(base.id)
                                            )
                                        }
                                        onChange={onToggleAll}
                                    />
                                </th>
                                <th className="text-right"></th>
                                <th className="text-right"></th>
                                <th className="text-center p-2"></th>
                                <th className="text-center p-2">Atualização</th>
                                <th className="text-center p-2">ID</th>
                                <th className="text-center p-2">Empreendimento</th>
                                <th className="text-center p-2">Status</th>
                                <th className="text-center p-2">Tipo</th>
                                <th className="text-center p-2">Padrão</th>
                                <th className="text-center p-2">Preço Médio</th>
                                <th className="text-center p-2">Preço Médio m<sup>2</sup></th>
                                <th className="text-center p-2">Endereço</th>
                                <th className="text-center p-2">Bairro</th>
                                <th className="text-center p-2">Usuário</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.map((base) => (
                                <tr key={base.id}>

                                    {/* Checkbox */}
                                    <td className="text-center">
                                        <input
                                            type="checkbox"
                                            className="checkbox check"
                                            checked={selectedBases.includes(base.id)}
                                            onChange={() =>
                                                onToggleBase(base.id)
                                            }
                                        />
                                    </td>

                                    {/* Ações de atualização */}
                                    <td className="text-right">

                                        {base.status_update !== 'Concluído' ? (
                                            <>
                                                <a
                                                    href={`/update-base/${base.id}`}
                                                    title="Atualização de Base"
                                                    className="btn btn-link btn-warning edit d-inline-block"
                                                >
                                                    <i className="fa fa-refresh"></i>
                                                </a>

                                                <a
                                                    href={`/repassar-ligacao/${base.id}`}
                                                    title="Transferir Ligação"
                                                    className="btn btn-link btn-warning edit d-inline-block"
                                                >
                                                    <i className="fa fa-exchange"></i>
                                                </a>
                                            </>
                                        ) : (
                                            <a
                                                href={`/update-base/${base.id}`}
                                                title="Atualização de Base"
                                                className="btn btn-link btn-success edit d-inline-block"
                                            >
                                                <i className="fa fa-edit"></i>
                                            </a>
                                        )}

                                    </td>

                                    {/* Avaliação */}
                                    <td className="text-right">
                                        <button
                                            type='button'
                                            title='Avaliar'
                                            className='btn btn-link btn-success edit d-inline-block'
                                            onClick={onShowModalAvaliacao}
                                        >
                                            <i className="fa fa-plus"></i>
                                        </button>
                                    </td>

                                    {/* Inconsistência */}
                                    <td>
                                        {base.inconsistencias > 0 &&
                                            base.status !== 'Esgotado' && (
                                                <span className="badge badge-warning">
                                                    Inconsistente
                                                </span>
                                            )}
                                    </td>

                                    {/* Atualização */}
                                    <td className="text-center">
                                        {this.renderUpdateStatus(
                                            base.status_update
                                        )}
                                    </td>

                                    {/* ID */}
                                    <td className="text-center">
                                        { base.building_id }
                                    </td>

                                    {/* Empreendimento */}
                                    <td className="text-center">

                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}
                                        >

                                            <div>
                                                <a
                                                    href={`/building/${base.building_id}`}
                                                    title="Cadastro do Empreendimento"
                                                    className="btn btn-link"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {base.name}
                                                    {' '}
                                                    <i className="fa fa-link"></i>
                                                </a>
                                            </div>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                }}
                                            >

                                                {base.source_info_access_id !== null && (
                                                    <span
                                                        title="Empreendimento com Parceria"
                                                        style={{
                                                            display: 'block',
                                                            width: '25px',
                                                            height: '25px',
                                                            borderRadius: '1px',
                                                            backgroundColor: '#0b63f3',
                                                            color: 'white',
                                                            padding: '3px',
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-p"></i>
                                                    </span>
                                                )}

                                                {base.previsao_lancamento !== null && (
                                                    <span
                                                        title="Empreendimento com Previsão de Lançamento"
                                                        style={{
                                                            display: 'block',
                                                            width: '25px',
                                                            height: '25px',
                                                            borderRadius: '1px',
                                                            backgroundColor: '#be34fe',
                                                            color: 'white',
                                                            padding: '3px',
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        <i className="fa-solid">
                                                            PL
                                                        </i>
                                                    </span>
                                                )}

                                            </div>
                                        </div>
                                    </td>

                                    {/* Status */}
                                    <td className="text-center">
                                        {this.renderBuildingStatus(base)}
                                    </td>

                                    {/* Tipo */}
                                    <td className="text-center">
                                        {base.type || '-'}
                                    </td>

                                    {/* Padrão */}
                                    <td className="text-center">
                                        {base.pattern || '-'}
                                    </td>

                                    {/* Preço médio */}
                                    <td className="text-center">
                                        {this.formatMoney(
                                            base.avg_ticket
                                        )}
                                    </td>

                                    {/* Preço médio m² */}
                                    <td className="text-center">
                                        {this.formatMoney(
                                            base.avg_ticket_meter_privative
                                        )}
                                    </td>

                                    {/* Endereço */}
                                    <td className="text-center">
                                        {base.address || '-'}
                                        {' '}
                                        {base.number || ''}
                                    </td>

                                    {/* Bairro */}
                                    <td className="text-center">
                                        {base.neighborhood || '-'}
                                    </td>

                                    {/* Usuário */}
                                    <td className="text-center">
                                        {base.user_assigned?.name || '-'}
                                    </td>

                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>

                <hr />

                {this.renderPagination()}
            </>
        );
    }

    renderPagination = () => {
        const {
            bases,
            onPageChange,
        } = this.props;

        if (!bases) {
            return null;
        }

        const {
            current_page,
            last_page,
        } = bases;

        if (!last_page || last_page <= 1) {
            return null;
        }

        return (
            <div className="d-flex justify-content-center">
                <nav>
                    <ul className="pagination">

                        <li
                            className={`page-item ${
                                current_page === 1
                                    ? 'disabled'
                                    : ''
                            }`}
                        >
                            <button
                                type="button"
                                className="page-link"
                                disabled={current_page === 1}
                                onClick={() =>
                                    onPageChange(current_page - 1)
                                }
                            >
                                Anterior
                            </button>
                        </li>

                        {Array.from(
                            { length: last_page },
                            (_, index) => index + 1
                        ).map((page) => (
                            <li
                                key={page}
                                className={`page-item ${
                                    page === current_page
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() =>
                                        onPageChange(page)
                                    }
                                >
                                    {page}
                                </button>
                            </li>
                        ))}

                        <li
                            className={`page-item ${
                                current_page === last_page
                                    ? 'disabled'
                                    : ''
                            }`}
                        >
                            <button
                                type="button"
                                className="page-link"
                                disabled={
                                    current_page === last_page
                                }
                                onClick={() =>
                                    onPageChange(current_page + 1)
                                }
                            >
                                Próxima
                            </button>
                        </li>

                    </ul>
                </nav>
            </div>
        );
    };
}

export default TabelaBases;